<script setup>
  import { useMapAdStore } from "@/stores/MapAdStore";

  import DataContainer from "@/components/DataContainer.vue";
  import MapAdSlot from '@/components/MapAdSlot.vue';

  const mapAdStore = useMapAdStore();

</script>

<template>

  <DataContainer 
    class="jwx-current-conditions-ad"
  >
    <MapAdSlot
      class="jwx-current-conditions-ad__slot"
      :adSlot="mapAdStore.currentAdSlot"
    />
  </DataContainer>
</template>